export const BASE_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:3000"
    : "https://qry.torchnyu.com";

export const courses = ["Computer Networks"];
